import { useTheme } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { IDarkTheme } from "styles/darkTheme";
import AppLogo from "assets/main-logo.svg";
import { Link } from "react-router-dom";
import styles from "./styles";

type IFooterProps = {
  isSM: boolean;
  widePad: string;
  smPad: string;
  marginTop?: string;
};

const footerLinks = [
  {
    title: "Privacy Policy",
    link: "/privacy-policy"
  },
  {
    title: "Terms of Service",
    link: "/terms-of-service"
  }
];
const Footer = ({
  isSM,
  widePad,
  smPad,
  marginTop = "100px !important"
}: IFooterProps) => {
  const theme = useTheme<IDarkTheme>();
  const classes = styles();

  return (
    <Box
      sx={{
        padding: isSM ? smPad : `0px ${widePad}`,
        marginTop: marginTop,
        width: "100%"
      }}
    >
      <Stack
        direction={"column"}
        alignItems={"center"}
        gap={"26px"}
        sx={{
          padding: "24px 16px",
          borderRadius: "30px",
          backgroundColor: theme.colors.secondary.secondary_30
        }}
      >
        <img
          src={AppLogo}
          alt={"Hoya App"}
          loading="lazy"
          className={classes.footerLogo}
        />
        <p>
          Copyright ® {new Date().getFullYear()} Company All rights reserved
        </p>
        <Box component="nav" sx={{ display: "flex" }}>
          {footerLinks.map((item) => (
            <Link key={item.link} to={item.link} className={classes.footerLink}>
              {item.title}
            </Link>
          ))}
        </Box>
      </Stack>
    </Box>
  );
};

export default Footer;
